import { render, staticRenderFns } from "./MailBox.vue?vue&type=template&id=4374aef0&scoped=true"
import script from "./MailBox.vue?vue&type=script&lang=js"
export * from "./MailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4374aef0",
  null
  
)

export default component.exports